import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { connect } from 'react-redux';

//Components MUi
import { TabContext, TabPanel } from '@mui/lab';
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Menu,
  Stack,
  styled,
  Tab,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { Spinner } from '../../components/Spinner';
import { StyledSubTabsScheduler } from '../../components/SubTabs.styles';
// Additional components
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import FullCalendar from '@fullcalendar/react';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import TuneIcon from '@mui/icons-material/Tune';
import moment from 'moment/moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LetsGoBtn } from '../../components/Buttons';
import Page from '../../components/Page';
import { monthFormattingByDate } from '../../helpers/date-helpers';
import './index.css';
import OrderDraggable from './orders/OrderDraggable';
import History from './tabs/History';
import Orders from './tabs/Orders';

//PNG
import OrdersPng from '../../assets/SchedulerOrdersIllustration.png';
import ApiService from '../../helpers/apiHelper';
import { useSnackbar } from 'notistack';
import SearchIcon from '@mui/icons-material/Search';

// import { useSelector } from 'react-redux';
const CssTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    fontSize: '16px', // default
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px'
    }
  },

  '& .MuiOutlinedInput-input': {
    fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
    fontFamily: 'FixelText-Medium !important',
    padding: '7px !important',
    [theme.breakpoints.up('xs')]: {
      padding: '2px !important'
    },
    [theme.breakpoints.up('sm')]: {
      padding: '7px !important'
    }
  },
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
}));
const StyledTab = styled((props) => {
  if (props?.disabled) {
    return (
      <Tooltip
        title={
          props.label === 'Замовлення' ? 'У Вас немає жодного товару' : 'У Вас немає жодного товару'
        }
        placement="top"
      >
        <span>
          <Tab disableRipple {...props} style={{ color: 'gray !important' }} />
        </span>
      </Tooltip>
    );
  } else {
    return <Tab disableRipple {...props} />;
  }
})(({ theme }) => ({
  textTransform: 'none',
  marginRight: '10px !important',
  marginLeft: '10px !important'
}));

function createData(
  color,
  comment,
  contacts,
  createdAt,
  createdBy,
  date,
  deliveryType,
  endHour,
  id,
  paymentType,
  service,
  startHour,
  title,
  qty,
  serviceID
) {
  return {
    color,
    comment,
    contacts,
    createdAt,
    createdBy,
    date,
    deliveryType,
    endHour,
    id,
    paymentType,
    service,
    startHour,
    title,
    qty,
    serviceID
  };
}

function SchedulerPage({ language, userData, savedCards, ...props }) {
  // eslint-disable-next-line
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const { enqueueSnackbar } = useSnackbar();
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);
  const [tabIdx, setTabIdx] = useState(params.get('tab'));
  const [selectedMonth, setSelectedMonth] = useState(
    `${monthFormattingByDate(new Date()).padStart(2, '0')}`
  );
  const [selectedYear, setSelectedYear] = useState(+new Date().getFullYear());
  const calendarRef = useRef(null);
  const [calendarContainer, setCalendarContainer] = useState(null);
  // eslint-disable-next-line

  const [statuses, setStatuses] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [ordersCounter, setOrdersCounter] = useState(null);

  const [distributedEvents, setDistributedEvents] = useState([]);

  const [selectedDay, setSelectedDay] = useState('');
  const [selectedDayElement, setSelectedDayElemet] = useState('');
  const [todayEvents, setTodayEvents] = useState([]);
  const apiMyOrders = new ApiService('posts/scheduler/orders');
  const apiOrderChangeTime = new ApiService('posts/order/change-time');
  // const apiMyOrders = new ApiService('/scheduler/orders');
  // const apiOrderChangeTime = new ApiService('/order/change-time');

  const handleEventDateChange = (date, id, startDate) => {
    const event = distributedEvents.find((d) => d.id === id);
    const newEvents = [...distributedEvents.filter((d) => d.id !== id), { ...event, date }];

    apiOrderChangeTime
      .postDataQuery({
        orderId: id,
        date
      })
      .then(async (res) => {
        // setSelectedDay(date);
        const selectedDayEvents = newEvents.filter((ev) => ev.date === startDate);
        setTodayEvents(selectedDayEvents);
        setDistributedEvents(newEvents);
      })
      .catch((error) => enqueueSnackbar('Сталася помилка', { variant: 'error' }));
  };
  // console.log(todayEvents);
  const downloadPDF = async () => {
    const pdf = await fetch(
      // `${window.config.REACT_APP_API_HOST_2}/openpdf/export`, {
      `${window.location.protocol}//${window.location.hostname}/v1/posts/openpdf/export`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('accessToken')
        },
        body: JSON.stringify(todayEvents.map((event) => event.id))
      }
    );
    const resolvedPdf = await pdf.arrayBuffer();

    if (resolvedPdf && pdf.status === 200) {
      const url = window.URL.createObjectURL(new Blob([resolvedPdf]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `Замовлення на ${moment(selectedDay).format('DD-MM-YYYY')}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      // eslint-disable-next-line
      throw 'Помилка скачування';
    }
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateCalendarDate = (selectedYear, selectedMonth) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(`${selectedYear}-${selectedMonth.toString()}-01`);
    }
  };
  const onYearChange = async (value) => {
    setSelectedYear(value);
    updateCalendarDate(value, selectedMonth);
    setTodayEvents([]);
  };

  const onMonthChange = async (value) => {
    setSelectedMonth(value);
    updateCalendarDate(selectedYear, value);
    setTodayEvents([]);
  };
  useEffect(() => {
    // document.addEventListener('DOMContentLoaded', function () {
    let containerEl = document.getElementById('external-events');

    // console.log(containerEl);
    if (containerEl) {
      new Draggable(containerEl, {
        itemSelector: '.draggableWrapper',
        eventData: function (eventEl) {
          let data = eventEl.getAttribute('data-event');
          let parsedData = JSON.parse(data);
          return {
            eventInfo: { ...JSON.parse(data) },
            title: parsedData.title,
            color: parsedData.color
          };
        }
      });
    }
    // });
  }, []);

  // eslint-disable-next-line
  const state = {
    weekendsVisible: true,
    currentEvents: []
  };

  const handleDateSelect = async (selectInfo) => {
    if (selectInfo?.startStr) {
      const selectedDayEvents = distributedEvents.filter((ev) => ev.date === selectInfo.startStr);
      setSelectedDay(selectInfo.startStr);
      setTodayEvents(selectedDayEvents);
      setSelectedDayElemet('');
      if (selectedDayElement.length !== 0) {
        const prevElement = document.getElementById(selectedDayElement);
        if (prevElement) {
          prevElement.remove();
        }
      }
    } else {
      if (selectedDayElement.length !== 0) {
        const prevElement = document.getElementById(selectedDayElement);
        if (prevElement) {
          prevElement.remove();
        }
      }
      const backgroundEl =
        selectInfo.jsEvent.target.parentElement.parentElement.parentElement.children[2];
      backgroundEl.insertAdjacentHTML(
        'beforeend',
        `
      <div id='${moment(selectInfo.date).format(
        'YYYY-MM-DD'
      )}select' class="fc-daygrid-bg-harness" style="left: 0px; right: 0px;"><div class="fc-highlight"></div></div>
  `
      );
      setSelectedDayElemet(`${moment(selectInfo.date).format('YYYY-MM-DD')}select`);

      const selectedDayEvents = distributedEvents.filter(
        (ev) => ev.date === moment(selectInfo.date).format('YYYY-MM-DD')
      );
      setSelectedDay(moment(selectInfo.date).format('YYYY-MM-DD'));
      setTodayEvents(selectedDayEvents);
    }
    // console.log('OPEN!', selectInfo);
  };

  const handleEventClick = (clickInfo) => {
    // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    //   clickInfo.event.remove();
    // }
  };

  function renderEventContent(eventInfo) {
    return (
      <>
        {/* <b>{eventInfo.timeText}</b> */}
        <i style={{ color: 'black', lineHeight: '12px', fontStyle: 'normal' }}>
          {eventInfo.event.title}
        </i>
      </>
    );
  }

  const handleChangeTab = async (event, newValue) => {
    params.set('tab', newValue);
    if (newValue === '1') {
      params.set('sd', params.get('sd') ? params.get('sd') : 'DESC');
      params.set('sf', params.get('sf') === 'true' ? params.get('sf') : 'false');
      params.set('status', '');
      params.set('question', '');
    }
    if (newValue === '2') {
      params.set('sd', params.get('sd') ? params.get('sd') : 'DESC');
      params.set('question', '');
      params.delete('status');
    }
    if (newValue === '3') {
      params.delete('sd');
      params.delete('status');
      params.delete('question');
    }
    setParams(params);
  };

  const autocompletesRenderer = async () => {
    const collection = document.getElementsByClassName('fc-toolbar-chunk');

    if (collection.length > 0) {
      const container = collection[2];

      if (container) {
        let root;

        if (!calendarContainer) {
          root = ReactDOM.createRoot(container);
          setCalendarContainer(root);
        } else {
          root = calendarContainer;
        }
        root.render(
          <div
            id="autocompleteContainer"
            style={{ width: '250px', display: 'flex', justifyContent: 'space-between' }}
          >
            <Autocomplete
              sx={{ width: '100px' }}
              disableClearable
              onKeyPress={(e) => {
                e.preventDefault();
              }}
              defaultValue={+new Date().getFullYear()}
              options={[2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]}
              getOptionLabel={(option) => option.toString()}
              onInputChange={(event, newValue) => onYearChange(newValue)}
              renderInput={(params) => (
                <CssTextField {...params} placeholder="Обери категорію товару*" />
              )}
            />
            <Autocomplete
              sx={{ width: '140px' }}
              disableClearable
              onKeyPress={(e) => {
                e.preventDefault();
              }}
              options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
              defaultValue={`${monthFormattingByDate(new Date()).padStart(2, '0')}`}
              getOptionLabel={(option) => {
                switch (option) {
                  case '01':
                    return 'Січень';
                  case '02':
                    return 'Лютий';
                  case '03':
                    return 'Березень';
                  case '04':
                    return 'Квітень';
                  case '05':
                    return 'Травень';
                  case '06':
                    return 'Червень';
                  case '07':
                    return 'Липень';
                  case '08':
                    return 'Серпень';
                  case '09':
                    return 'Вересень';
                  case '10':
                    return 'Жовтень';
                  case '11':
                    return 'Листопад';
                  case '12':
                    return 'Грудень';
                  default:
                    return;
                }
              }}
              onChange={(event, newValue) => onMonthChange(newValue)}
              renderInput={(params) => <CssTextField {...params} placeholder="Місяць" />}
            />
          </div>
        );
      }
    }
  };

  useEffect(() => {
    tabIdx === '3' && !document.getElementById('') && autocompletesRenderer();
    return () => setCalendarContainer(null);
    // eslint-disable-next-line
  }, [tabIdx]);

  useEffect(() => {
    const tab = params.get('tab');
    const isPremium = userData?.role === 'PREMIUM_USER';

    let nextTab = '2';
    if (isPremium) {
      if (tab === '1') {
        nextTab = '1';
      } else if (tab === '2') {
        nextTab = '2';
      } else if (tab === '3') {
        nextTab = '3';
      }
    } else {
      if (tab === '1') {
        nextTab = '1';
      } else if (tab === '2') {
        nextTab = '2';
      } else if (tab === '3') {
        nextTab = '2';
      }
    }

    setTabIdx(nextTab);
    if (params.get('tab') !== nextTab) {
      params.set('tab', nextTab);
      setParams(params);
    }
    // eslint-disable-next-line
  }, [params.get('tab'), userData]);

  useEffect(() => {
    window.location.href.includes('scheduler') &&
      params.get('question') &&
      setSearchValue(params.get('question'));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (params.get('status') && params.get('status').length !== 0) {
      setStatuses(params.get('status').split(','));
    } else {
      setStatuses([]);
    }
    // eslint-disable-next-line
  }, [params.get('status')]);

  useEffect(() => {
    if (!selectedDay || selectedDay.length === 0) {
      const todayDate = moment(new Date()).format('YYYY-MM-DD');
      const todayEventsList = distributedEvents.filter((ev) => ev.date === todayDate);
      setTodayEvents([...todayEventsList]);
    }

    // eslint-disable-next-line
  }, [distributedEvents, selectedDay]);
  useEffect(() => {
    const todayDate = moment(new Date()).format('YYYY-MM-DD');
    setSelectedDay(todayDate);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    let mounted = true;
    if (tabIdx === '3' && mounted) {
      apiMyOrders
        .getAll({
          from: 0,
          size: 366,
          search: '',
          sortOrder: 'DESC',
          status: 'PROCESSING'
        })
        .then((res) => {
          const dates = res.result.map((el) =>
            createData(
              '#99D896',
              el?.details?.comment,
              el?.details?.contact,
              moment(new Date(el?.buyingDate)).format('YYYY-MM-DD'),
              `${el?.buyer?.surname} ${el?.buyer?.name}`,
              moment(new Date(el?.estimatedTimeShipment)).format('YYYY-MM-DD'),

              el?.details?.deliveryType,
              '05:00 AM',
              el?.id,
              el?.details?.paymentType,
              el?.service?.nameService,
              '04:00 AM',
              el?.orderNumber,
              el?.qty,
              el?.service?.id
            )
          );
          setDistributedEvents([...dates]);
        });
    }
    return () => (mounted = false);
    // eslint-disable-next-line
  }, []);

  return (
    <Page
      title="Замовлення"
      sx={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px 80px', sm: '0px 20px 80px', md: '0px 80px', lg: '0px 100px 80px' }
      }}
    >
      <Stack
        spacing={1}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height={isLoading ? '80vh' : '100%'}
      >
        {!isLoading ? (
          <Grid
            container
            style={{
              maxWidth: '1440px'
            }}
          >
            <TabContext value={tabIdx}>
              <Grid
                item
                xs={12}
                sx={{
                  p: 1,
                  minHeight: '90px',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <StyledSubTabsScheduler
                  sx={{
                    maxWidth: 'unset !important',
                    '& .MuiTabs-flexContainer': {
                      justifyContent: 'space-between',
                      width:
                        userData && userData?.role === 'PREMIUM_USER'
                          ? '390px !important'
                          : '250px !important',
                      maxWidth: 'unset !important'
                    }
                  }}
                  onChange={handleChangeTab}
                >
                  <StyledTab
                    // disabled={userData && userData?.countServices === 0}
                    value="1"
                    label="Продажі"
                  />

                  <StyledTab value="2" label="Покупки" />
                  {userData && userData?.role === 'PREMIUM_USER' ? (
                    <StyledTab
                      disabled={userData && userData?.countServices === 0}
                      value="3"
                      label="Календар"
                    />
                  ) : null}
                </StyledSubTabsScheduler>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  p: 1,
                  minHeight: '60vh',
                  flexDirection: 'column'
                  // maxHeight: '60vh',
                  // overflow: 'scroll',
                  // '&::-webkit-scrollbar': { display: 'none' },
                  // msOverflowStyle: 'none',
                  // scrollbarWidth: 'none'
                }}
              >
                <TabPanel value="1">
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: { xs: '16px', md: '400px' },
                      flexDirection: { xs: 'column', sm: 'row' }
                    }}
                  >
                    {(tabIdx === '1' || tabIdx === '2') && (
                      <TextField
                        variant="outlined"
                        style={{ maxWidth: '500px !important' }}
                        sx={{
                          maxWidth: '500px !important',
                          input: {
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: '16px',
                            fontWeight: '350',
                            lineHeight: '19px',
                            letterSpacing: '0em',
                            textAlign: 'left',

                            '&::placeholder': {
                              fontFamily: 'FixelText-Medium !important',
                              color: '#7c7c7c',
                              fontSize: '16px',
                              fontWeight: '350',
                              lineHeight: '19px',
                              letterSpacing: '0em',
                              textAlign: 'left'
                              // <----- Add this.
                              // opacity: 1,
                            }
                          }
                        }}
                        placeholder="Пошук замовлень"
                        fullWidth
                        value={searchValue}
                        onChange={(e) =>
                          e.target?.value !== null
                            ? setSearchValue(e.target.value)
                            : setSearchValue('')
                        }
                        InputProps={{
                          endAdornment: (
                            <>
                              {searchValue.length !== 0 && (
                                <ClearIcon
                                  sx={{
                                    cursor: 'pointer',
                                    ':hover': {
                                      color: '#60A5DF'
                                    }
                                  }}
                                  onClick={() => {
                                    setSearchValue('');
                                    navigate(`/${language}/scheduler?&tab=${params.get('tab')}`);
                                  }}
                                />
                              )}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '47px',
                                  height: '40px',
                                  cursor: 'pointer',
                                  borderRadius: '40px',
                                  backgroundColor: 'white'
                                }}
                                onClick={() => {
                                  params.set('question', searchValue);
                                  setParams(params);
                                  // navigate(
                                  //   `/${language}/scheduler?question=${searchValue}&tab=${params.get(
                                  //     'tab'
                                  //   )}`
                                  // );
                                }}
                              >
                                <SearchIcon
                                  sx={{
                                    color: '#60A5DF',
                                    cursor: 'pointer',
                                    ':hover': {
                                      color: '#60A5DF'
                                    }
                                  }}
                                />
                              </div>
                            </>
                          )
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            params.set('question', searchValue);
                            setParams(params);
                            // navigate(
                            //   `/${language}/scheduler?question=${searchValue}&tab=${params.get('tab')}`
                            // );
                          }
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center'
                      }}
                    >
                      {tabIdx === '1' && (
                        <Box
                          onClick={handleClick}
                          sx={{
                            cursor: 'pointer',
                            alignItems: 'center',
                            display: 'flex',
                            marginRight: '10px',
                            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                            p: { xs: '9px', sm: '14px 8px' },
                            backgroundColor: 'white',
                            fontSize: { xs: '14px', sm: '16px' },
                            borderRadius: '8px'
                          }}
                        >
                          <TuneIcon
                            sx={
                              open
                                ? {
                                    fontSize: '25px',
                                    marginRight: '10px',
                                    color: '#60A5DF',
                                    display: { xs: 'none', sm: 'block' }
                                  }
                                : {
                                    fontSize: '25px',
                                    marginRight: '10px',
                                    display: { xs: 'none', sm: 'block' }
                                  }
                            }
                          />
                          {'Фільтрувати'}
                          {open ? (
                            <ArrowDropUpOutlinedIcon sx={{ ml: 5 }} />
                          ) : (
                            <ArrowDropDownOutlinedIcon sx={{ ml: 5 }} />
                          )}
                        </Box>
                      )}
                      <Menu
                        anchorEl={anchorEl}
                        id="scheduler-filter-menu"
                        open={open}
                        onClose={handleClose}
                        // onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: 'visible',

                            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                            borderRadius: '5px',
                            border: 'none',
                            paddingTop: '10px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            width: '250px',
                            mt: 1.5
                          }
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      >
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography
                              style={{
                                fontWeight: '500',
                                fontFamily: 'FixelText-Medium',

                                marginBottom: '10px'
                              }}
                            >
                              Статус замовлення
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disableRipple
                                    checked={statuses.includes('NEW')}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStatuses([...statuses, 'NEW']);
                                      }
                                      if (!e.target.checked) {
                                        setStatuses([...statuses.filter((el) => el !== 'NEW')]);
                                      }
                                    }}
                                  />
                                }
                                label="Нове"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disableRipple
                                    checked={statuses.includes('PROCESSING')}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStatuses([...statuses, 'PROCESSING']);
                                      }
                                      if (!e.target.checked) {
                                        setStatuses([
                                          ...statuses.filter((el) => el !== 'PROCESSING')
                                        ]);
                                      }
                                    }}
                                  />
                                }
                                label="В обробці"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disableRipple
                                    checked={statuses.includes('SENT')}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStatuses([...statuses, 'SENT']);
                                      }
                                      if (!e.target.checked) {
                                        setStatuses([...statuses.filter((el) => el !== 'SENT')]);
                                      }
                                    }}
                                  />
                                }
                                label="Відправлено"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disableRipple
                                    checked={statuses.includes('DONE')}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStatuses([...statuses, 'DONE']);
                                      }
                                      if (!e.target.checked) {
                                        setStatuses([...statuses.filter((el) => el !== 'DONE')]);
                                      }
                                    }}
                                  />
                                }
                                label="Отримано"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disableRipple
                                    checked={statuses.includes('CANCELED')}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStatuses([...statuses, 'CANCELED']);
                                      }
                                      if (!e.target.checked) {
                                        setStatuses([
                                          ...statuses.filter((el) => el !== 'CANCELED')
                                        ]);
                                      }
                                    }}
                                  />
                                }
                                label="Скасовано"
                              />
                            </FormGroup>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}
                          >
                            <LetsGoBtn
                              colorScheme="blue"
                              onClick={() => {
                                params.set('status', statuses);
                                setParams(params);
                                handleClose();
                              }}
                              text="Застосувати фільтри"
                            />
                          </Grid>
                          {tabIdx === '1' && (
                            <Grid
                              item
                              xs={12}
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 1,
                                mb: 1,
                                alignItems: 'center'
                              }}
                            >
                              <Typography
                                fontSize={14}
                                variant="body"
                                sx={{
                                  mb: 2,
                                  textDecoration: 'underline',
                                  fontWeight: '700',
                                  cursor: 'pointer',
                                  zIndex: '99',
                                  ':hover': {
                                    fontWeight: '1000'
                                  }
                                }}
                                onClick={() => {
                                  params.set('status', '');
                                  setParams(params);
                                  setStatuses([]);
                                }}
                              >
                                Очистити фільтри
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Menu>
                      <Autocomplete
                        disableClearable
                        onKeyPress={(e) => {
                          e.preventDefault();
                        }}
                        options={['Безпечна оплата', 'Спочатку нові', 'Спочатку старіші']}
                        sx={{ width: 160 }}
                        value={
                          params.get('sf') !== 'true'
                            ? params.get('sd') === 'DESC'
                              ? 'Спочатку нові'
                              : 'Спочатку старіші'
                            : 'Безпечна оплата'
                        }
                        onChange={(event, value) => {
                          if (value === 'Спочатку нові') {
                            params.set('sd', 'DESC');
                            params.set('sf', 'false');
                            setParams(params);
                          } else if (value === 'Спочатку старіші') {
                            params.set('sd', 'ASC');
                            params.set('sf', 'false');
                            setParams(params);
                          } else {
                            params.set('sf', 'true');
                            params.set('sd', 'DESC');
                            setParams(params);
                          }
                        }}
                        renderInput={(params) => <CssTextField {...params} variant="outlined" />}
                      />
                    </Box>
                  </Box>
                  {params.get('tab') === '1' && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        mt: '16px',
                        justifyContent: { xs: 'center', sm: 'space-between' },
                        alignItems: 'flex-end'
                      }}
                    >
                      {ordersCounter && (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'row',
                            flexWrap: { xs: 'wrap', sm: 'nowrap' }
                          }}
                        >
                          <Typography
                            component={'span'}
                            sx={{
                              fontFamily: 'FixelText-Medium !important',
                              lineHeight: '14px',
                              fontWeight: 500,
                              display: 'flex',
                              alignItems: 'center',
                              border: 'none',
                              borderRadius: '8px',
                              p: '8px',
                              background: '#E2F2FF',
                              width: 'fit-content',
                              mr: '8px',
                              fontSize: '14px'
                            }}
                          >
                            Нові замовлення:
                            <Typography
                              // variant="subtitle2"
                              sx={{
                                fontSize: 14,
                                fontFamily: 'FixelText-Medium',

                                ml: 0.5
                              }}
                            >
                              {`${ordersCounter?.new > 2 ? '' : ''}${ordersCounter?.new}`}
                            </Typography>
                          </Typography>
                          <Typography
                            component={'span'}
                            sx={{
                              fontFamily: 'FixelText-Medium !important',
                              lineHeight: '14px',
                              fontWeight: 500,
                              display: 'flex',
                              alignItems: 'center',
                              border: 'none',
                              borderRadius: '8px',
                              p: '8px',
                              background: '#F5F4F4',
                              width: 'fit-content',
                              mr: '0',
                              fontSize: '14px'
                            }}
                          >
                            Очікують відправки:
                            <Typography
                              // variant="subtitle2"
                              sx={{
                                fontSize: 14,
                                fontFamily: 'FixelText-Medium',

                                ml: 0.5
                              }}
                            >
                              {`${ordersCounter?.sentAwait > 2 ? '+' : ''}${
                                ordersCounter?.sentAwait
                              }`}
                            </Typography>
                          </Typography>
                          <Typography
                            component={'span'}
                            sx={{
                              fontFamily: 'FixelText-Medium !important',
                              lineHeight: '14px',
                              fontWeight: 500,
                              display: 'flex',
                              alignItems: 'center',
                              border: 'none',
                              borderRadius: '8px',
                              p: '8px',
                              background: '#D4ECCF',
                              width: 'fit-content',
                              ml: { xs: '0px', sm: '8px' },
                              mt: { xs: '10px', sm: '0px' },
                              fontSize: '14px',
                              color: '#29A10E'
                            }}
                          >
                            Безпечна оплата:
                            <Typography
                              // variant="subtitle2"
                              sx={{
                                fontSize: 14,
                                fontFamily: 'FixelText-Medium',
                                color: '#29A10E',
                                ml: 0.5
                              }}
                            >
                              {`${ordersCounter?.safe}`}
                            </Typography>
                          </Typography>
                        </Box>
                      )}
                      {savedCards &&
                      savedCards?.length > 0 &&
                      savedCards.some((card) => card?.isActive === true) ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                          <Typography
                            sx={{
                              fontFamily: 'FixelText-Medium',

                              fontSize: { xs: '14px', sm: '16px' },
                              cursor: 'pointer',
                              width: 'max-content',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            {`Картка для виплат: ${
                              savedCards.find((card) => card?.isActive)?.cardMask
                            }`}
                          </Typography>{' '}
                          <Typography
                            sx={{
                              fontFamily: 'FixelText-Medium',
                              color: '#60A5DF',
                              fontSize: { xs: '14px', sm: '16px' },
                              cursor: 'pointer',
                              width: 'max-content',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            onClick={() => navigate('/ua/account-settings')}
                          >
                            Налаштування карток
                          </Typography>{' '}
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                          <Typography
                            sx={{
                              fontFamily: 'FixelText-Medium',
                              color: '#F64D36',
                              fontSize: { xs: '14px', sm: '16px' },
                              cursor: 'pointer',
                              width: 'max-content',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            У Вас не обрана картка:
                          </Typography>{' '}
                          <Typography
                            sx={{
                              fontFamily: 'FixelText-Medium',
                              color: '#60A5DF',
                              fontSize: { xs: '14px', sm: '16px' },
                              cursor: 'pointer',
                              width: 'max-content',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            onClick={() => navigate('/ua/account-settings')}
                          >
                            {/*<Add sx={{ color: '#60A5DF' }} />*/}
                            Обрати картку для виплат
                          </Typography>
                        </Box>
                      )}
                    </Grid>
                  )}

                  <Orders countSetter={setOrdersCounter} />
                </TabPanel>
                <TabPanel value="2">
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: { xs: '16px', md: '400px' },
                      flexDirection: { xs: 'column', sm: 'row' }
                    }}
                  >
                    {(tabIdx === '1' || tabIdx === '2') && (
                      <TextField
                        variant="outlined"
                        style={{ maxWidth: '500px !important' }}
                        sx={{
                          maxWidth: '500px',
                          input: {
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: '16px',
                            fontWeight: '350',
                            lineHeight: '19px',
                            letterSpacing: '0em',
                            textAlign: 'left',

                            '&::placeholder': {
                              fontFamily: 'FixelText-Medium !important',
                              color: '#7c7c7c',
                              fontSize: '16px',
                              fontWeight: '350',
                              lineHeight: '19px',
                              letterSpacing: '0em',
                              textAlign: 'left'
                              // <----- Add this.
                              // opacity: 1,
                            }
                          }
                        }}
                        placeholder="Пошук замовлень"
                        fullWidth
                        value={searchValue}
                        onChange={(e) =>
                          e.target?.value !== null
                            ? setSearchValue(e.target.value)
                            : setSearchValue('')
                        }
                        InputProps={{
                          endAdornment: (
                            <>
                              {searchValue.length !== 0 && (
                                <ClearIcon
                                  sx={{
                                    cursor: 'pointer',
                                    ':hover': {
                                      color: '#60A5DF'
                                    }
                                  }}
                                  onClick={() => {
                                    setSearchValue('');
                                    navigate(`/${language}/scheduler?&tab=${params.get('tab')}`);
                                  }}
                                />
                              )}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '47px',
                                  height: '40px',
                                  cursor: 'pointer',
                                  borderRadius: '40px',
                                  backgroundColor: 'white'
                                }}
                                onClick={() => {
                                  params.set('question', searchValue);
                                  setParams(params);
                                  // navigate(
                                  //   `/${language}/scheduler?question=${searchValue}&tab=${params.get(
                                  //     'tab'
                                  //   )}`
                                  // );
                                }}
                              >
                                <SearchIcon
                                  sx={{
                                    color: '#60A5DF',
                                    cursor: 'pointer',
                                    ':hover': {
                                      color: '#60A5DF'
                                    }
                                  }}
                                />
                              </div>
                            </>
                          )
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            params.set('question', searchValue);
                            setParams(params);
                            // navigate(
                            //   `/${language}/scheduler?question=${searchValue}&tab=${params.get('tab')}`
                            // );
                          }
                        }}
                      />
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                      <Autocomplete
                        disableClearable
                        onKeyPress={(e) => {
                          e.preventDefault();
                        }}
                        options={['Спочатку нові', 'Спочатку старіші']}
                        sx={{ width: 160 }}
                        value={params.get('sd') === 'DESC' ? 'Спочатку нові' : 'Спочатку старіші'}
                        onChange={(event, value) => {
                          if (value === 'Спочатку нові') {
                            params.set('sd', 'DESC');
                            setParams(params);
                          } else {
                            params.set('sd', 'ASC');
                            setParams(params);
                          }
                        }}
                        renderInput={(params) => <CssTextField {...params} variant="outlined" />}
                      />
                    </Box>
                  </Box>

                  <History />
                </TabPanel>
                <TabPanel value="3">
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      flexDirection: { xs: 'column-reverse', sm: 'column-reverse', md: 'row' }
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      md={4.5}
                      sx={{
                        justifyContent: { xs: 'center', md: 'start' },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-end',
                          justifyContent: 'space-between',
                          maxWidth: '500px',
                          width: '100%'
                        }}
                      >
                        <Typography
                          sx={{
                            mt: { xs: '24px', md: '0px' },
                            mb: '16px',
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: { xs: '14px', sm: '20px' },
                            fontWeight: 500
                          }}
                        >
                          Дата відправки товару:{' '}
                        </Typography>
                        <Typography
                          sx={{
                            mt: { xs: '24px', md: '0px' },
                            mb: '16px',
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: { xs: '14px', sm: '20px' },
                            fontWeight: 500
                          }}
                        >
                          {moment(selectedDay).format('DD.MM.YYYY')}
                        </Typography>
                        {/*{todayEvents.length !== 0 && (*/}
                        {/*  <Tooltip title="Завантажити в PDF" placement="top">*/}
                        {/*    <LocalPrintshopOutlinedIcon*/}
                        {/*      onClick={downloadPDF}*/}
                        {/*      sx={{ color: '#60A5DF', mb: '12px', cursor: 'pointer' }}*/}
                        {/*    />*/}
                        {/*  </Tooltip>*/}
                        {/*)}*/}
                      </Box>

                      <Box
                        id="external-events"
                        className="eventsListWrapper"
                        sx={{
                          maxWidth: '500px',
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'start',
                          border: 'none',
                          borderRadius: '5px',
                          // height: 'calc(600px - 50px)',
                          height: 'fit-content',
                          p: 0.2,
                          backgroundColor: 'white',
                          overflow: 'scroll',
                          scrollbarWidth: 'none',
                          '&::-webkit-scrollbar': {
                            display: 'none'
                          }
                        }}
                      >
                        {todayEvents.length !== 0 ? (
                          todayEvents.map((ev, index) => (
                            <OrderDraggable
                              key={`eventDrag${index}`}
                              index={index}
                              event={ev}
                              calendarFunc={handleEventDateChange}
                            />
                          ))
                        ) : (
                          <>
                            <Typography
                              sx={{
                                mt: 10,
                                mb: 4,
                                maxWidth: '300px',
                                fontSize: '16px',
                                textAlign: 'center'
                              }}
                              variant="body2"
                            >
                              Тут відображатимуться замовлення, які перебувають у статусі “В
                              обробці” та автоматично визначені на конкретний день відправки. Ви
                              можете змінити дату відправки, перетягнувши відповідне замовлення на
                              інший день у календарі.
                            </Typography>
                            <img src={OrdersPng} alt="ordersIllustration" width={330} />
                          </>
                        )}
                      </Box>
                      {todayEvents.length !== 0 && (
                        <LetsGoBtn
                          width="210px"
                          margin="16px"
                          colorScheme="white"
                          onClick={downloadPDF}
                          text="Завантажити у PDF"
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} md={7.5}>
                      <FullCalendar
                        ref={calendarRef}
                        events={distributedEvents}
                        locale="uk"
                        plugins={[dayGridPlugin, interactionPlugin, momentPlugin]}
                        titleFormat={'DD-MM-YYYY'}
                        headerToolbar={{
                          left: '',
                          center: '',
                          right: ''
                        }}
                        customButtons={{
                          titleCustom: {
                            text: 'Календар'
                          }
                        }}
                        moreLinkContent={(data) => `${data.num}${data.num > 4 ? '+' : ''}`}
                        moreLinkClick={(info) => {
                          handleDateSelect(info);
                          return 'test';
                        }}
                        moreLinkText={``}
                        dayMaxEventRows={0}
                        eventDrop={(info) => {
                          // const event = distributedEvents.find((ev) => ev.id === info.event.id);
                          // const newEvents = distributedEvents.filter(
                          //   (ev) => ev.id !== info.event.id
                          // );
                          // setDistributedEvents([
                          //   ...newEvents,
                          //   { ...event, date: info.event.startStr }
                          // ]);
                        }}
                        eventReceive={(info) => {
                          const today = new Date().setHours(0, 0, 0, 0);
                          const eventStart = info.event.start.setHours(0, 0, 0, 0);
                          const newEvent = {
                            ...info.event.extendedProps.eventInfo,
                            date: info.event.startStr
                          };
                          if (today <= eventStart) {
                            apiOrderChangeTime
                              .postDataQuery({
                                orderId: newEvent?.id,
                                date: moment(new Date(info.event.start)).format('YYYY-MM-DD')
                              })
                              .then((res) => {
                                const allEventsRefresh = distributedEvents.filter(
                                  (ev) => ev.id !== newEvent.id
                                );
                                setDistributedEvents([...allEventsRefresh, newEvent]);
                              })
                              .catch((error) =>
                                enqueueSnackbar('Сталася помилка', { variant: 'error' })
                              );
                          }
                          info.revert();
                        }}
                        droppable={true}
                        initialView="dayGridMonth"
                        editable={false}
                        selectable={true}
                        selectMirror={false}
                        weekends={state.weekendsVisible}
                        select={handleDateSelect}
                        eventContent={renderEventContent} // custom render function
                        eventClick={handleEventClick}
                      />
                    </Grid>

                    {/* <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography variant="subtitle2" sx={{ mt: '20px', mb: '12px' }}>
                        {selectedDay}
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          justifyContent: 'start',
                          flexDirection: todayEvents.length === 0 ? 'column' : 'row',
                          border: '1px solid #60A5DF',
                          height: '100%',
                          backgroundColor: 'white',
                          p: 1,
                          maxHeight: '500px',
                          overflow: 'scroll',
                          scrollbarWidth: 'none',
                          '&::-webkit-scrollbar': {
                            display: 'none'
                          }
                        }}
                      >
                        {todayEvents.length !== 0 ? (
                          todayEvents.map((ev, index) => (
                            <TodayEvent
                              setTodayEvents={setTodayEvents}
                              todayEvents={todayEvents}
                              setDistributedEvents={setDistributedEvents}
                              distributedEvents={distributedEvents}
                              allEvents={allEvents}
                              setAllevents={setAllevents}
                              key={`todayEv${index}`}
                              event={ev}
                            />
                          ))
                        ) : (
                          <>
                            <StyledTitle
                              maxWidth={800}
                              sx={{
                                lineHeight: '58px !important',
                                textTransform: 'unset',
                                marginBottom: '10px !important',
                                fontSize: '32px !important'
                              }}
                              className="bottomBlock-title"
                            >
                              Тут порожньо
                            </StyledTitle>
                            <Typography sx={{ mt: 1, mb: 5 }} variant="body2">
                              Поки що нічого не заплановано
                            </Typography>
                          </>
                        )}
                      </Box>
                    </Grid> */}
                  </Grid>
                </TabPanel>
              </Grid>
            </TabContext>
          </Grid>
        ) : (
          <Spinner />
        )}
      </Stack>
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    savedCards: state.global.savedCards
  };
};

export default connect(mapStateToProps)(React.memo(SchedulerPage));
